import { render, staticRenderFns } from "./t-footer.vue?vue&type=template&id=1a1c6fab&"
import script from "./t-footer.vue?vue&type=script&lang=js&"
export * from "./t-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports